import templateOnly from '@ember/component/template-only';

const SharedDropZoneCompactErrors = templateOnly();
export default SharedDropZoneCompactErrors;
